import { EventEmitter, Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from './auth.service';
import { AngularFireStorage } from '@angular/fire/storage';
import axios from 'axios';
import { HttpClient } from '@angular/common/http';
import { User } from '../shared/models/user';
import { IEvent } from '../shared/models/event';
import { Observable, of } from 'rxjs';
import { Timestamp } from '@google-cloud/firestore';

const QRCode = require('qrcode');
export interface ISendNotificationOfCreatedEvent {
  user: any,
  notificationTitle: string,
  event: IEvent
}

@Injectable({
  providedIn: 'root'
})
export class DataService {
  public monthNotifications: number;
  public userId: string;
  public loading = false;
  public $rentals = new EventEmitter();
  public $accountLog = new EventEmitter();
  public $eventSaved = new EventEmitter();
  public rentedEventInfo: any = { }
  public currentCriteria = 'category';
  private rapidKey = 'bc11b2d1a4mshaaef35331e8271ap13cf22jsna02a131a79a6';
  public categories: any[] = [];

  constructor(public afs: AngularFirestore,   // Inject Firestore service
    private storage: AngularFireStorage,
    private http: HttpClient,
    private _snackBar: MatSnackBar) { }

  public async updateUserInfo(user: any, brandId: string): Promise<any> {
    try {

      console.log('');
      console.log('');
      console.log('user ', user);
      console.log('');
      console.log('');
      // Download and save the image, assuming downloadAndSaveImage returns the image URL
      const saveProfilePhoto = await this.downloadAndSaveImage(user.photoURL, user.email);
  
      // Get the brand object using user's brandId
      const brandRef: AngularFirestoreDocument<any> = this.afs.doc(`brands/${brandId}`);
      const brandData = (await brandRef.get().toPromise()).data();
  
      // Update the brand's image in the brand object
      if (brandData) {
        console.log('');
        console.log('');
        console.log('brandData ', brandData);
        console.log('user?.displayName ', user?.displayName);
        console.log('');
        brandData.image = saveProfilePhoto;
        brandData.bio = user.bio;
        brandData.locationLink = user?.locationLink;
        brandData.whatsappNumber = user?.whatsapp;
        brandData.name = user?.displayName;
        if (user?.instagram) 
        brandData.instagram = user?.instagram;
        await brandRef.set(brandData, { merge: true });
      }
  
      return true; // Indicate success
    } catch (error) {
      this.somethingWentWrong(error, 'Error updating user information.');
      throw error;
    }
  }
    
    
  public somethingWentWrong(error: any, message?: string): void {
    let mess = message? message: 'Algo salió mal'
    console.log(error)
    this._snackBar.open(mess, 'Ok', {
      duration: 3000
    });
  }
 
  async downloadAndSaveImage(url: string, fileName: string): Promise<string> {
    const proxyUrl = 'https://corsproxy.io/?' + encodeURIComponent(url);
    try {
      const response = await axios.get(`${proxyUrl}${url}`, {
        responseType: 'arraybuffer'
      });
      const imageBlob = new Blob([response.data], { type: 'image/jpeg' }); // Assuming the image is a JPEG

      const storageRef = this.storage.ref(`brands/${fileName}`);
      const uploadTaskSnapshot = await storageRef.put(imageBlob);

      const downloadURL = await uploadTaskSnapshot.ref.getDownloadURL();
      console.log('Image saved to Firebase Storage:', downloadURL);
      return downloadURL;
    } catch (error) {
      console.error('Failed to download or save image:', error);
      return '';
    }
  }

  async getBrandData(brandId: string): Promise<any> {
    try {
      const snapshot = await this.afs.collection('brands').doc(brandId).get().toPromise();
      return snapshot.data();
    } catch (error) {
      // Handle any errors here, e.g., log the error or throw a custom error
      console.error('Error fetching user info DDDDD:', error);
      throw error; // You can choose to throw the error for handling in the caller or handle it here
    }
  }

  async getUserInfo(uid: string): Promise<any> {
    try {
      const snapshot = await this.afs.collection('users').doc(uid).get().toPromise();
      return snapshot.data();
    } catch (error) {
      // Handle any errors here, e.g., log the error or throw a custom error
      console.error('Error fetching user info DDDDD:', error);
      throw error; // You can choose to throw the error for handling in the caller or handle it here
    }
  }

  async getCategories(): Promise<any[]> {
    try {
      const snapshot = await this.afs.collection('categories').get().toPromise();
      return snapshot.docs.map((doc) => doc.data());
    } catch (error) {
      // Handle any errors here, e.g., log the error or throw a custom error
      console.error('Error fetching categories:', error);
      throw error; // You can choose to throw the error for handling in the caller or handle it here
    }
  }

   dataURItoBlob(dataURI: string) {
    // Split the data URI into parts to get the MIME type and base64 data
    const parts = dataURI.split(';');
    const base64 = atob(parts[1].split(',')[1]);
    
    // Convert the base64 data to a Uint8Array
    const array = new Uint8Array(base64.length);
    for (let i = 0; i < base64.length; i++) {
      array[i] = base64.charCodeAt(i);
    }
  
    // Create a Blob from the Uint8Array and MIME type
    return new Blob([array], { type: 'image/webp' });
  }

  async downloadAndSaveEventImage(imageBlob: Blob, fileName: string): Promise<string> {
    try {
      const storageRef = this.storage.ref(`events/${fileName}`);
      const uploadTaskSnapshot = await storageRef.put(imageBlob);
  
      const downloadURL = await uploadTaskSnapshot.ref.getDownloadURL();
      console.log('Image saved to Firebase Storage:', downloadURL);
      return downloadURL;
    } catch (error) {
      throw error;
    }
  }
  
  private getSearchTags(brand: string, description: string): string[] {
    const brandTags = this.extractSubstrings(brand);
    const descriptionTags = this.extractWords(description);
    
    // Combine brand and description tags into a single array
    const searchTags = [...brandTags, ...descriptionTags];
  
    return searchTags;
  }
  
  private extractSubstrings(inputString: string): string[] {
    const substrings: string[] = [];
  
    for (let i = 0; i < inputString.length; i++) {
      for (let j = i + 1; j <= inputString.length; j++) {
        const substring = inputString.substring(i, j);
        substrings.push(substring);
      }
    }
  
    return substrings;
  }
  
  private extractWords(inputString: string): string[] {
    // Use a regular expression to extract words
    const words = inputString.match(/\b\w+\b/g) || [];
    return words;
  }

  getEventReservations(eventId: string): Observable<any[]> {
    return this.afs.collection('events-reservation', ref => ref.where('eventId', '==', eventId)).valueChanges();
  }
  

  public async createEvent(event: IEvent, user: any, sendNotification: boolean): Promise<void> {

    const id = this.afs.createId();
    if (!event.image.includes('http')) {
      const blobImage = this.dataURItoBlob(event.image)
      event.image = await this.downloadAndSaveEventImage(blobImage, id);
    } else {
      try {
        event.image = await this.downloadAndSaveImage(event.image, id);
      } catch(e) {
        
      }
    }

    const userInfo: any = await this.getUserInfo(user.uid ? user.uid: user.userId);
    const brandId = userInfo.brandId;

    const searchTags = this.getSearchTags(user.displayName, event.description);

    const now = new Date();

    const eventObject = {
      createdAt: now,
      ...event,
      searchTags
    };
    const notId = this.afs.createId();

    await this.afs.doc(`notifications/${notId}`).set({
      id: notId,
      brand: brandId,
      brandImage: user.image,
      title: event.fullName,
      description: event.description,
      eventId: id,
      timestamp: new Date()
    });

    // Step 1: Get the followers of the brand
    const followersSnapshot = await this.afs
    .collection(`followers/${brandId}/user-followers`)
    .get().toPromise();

    const followers = followersSnapshot.docs.map((doc) => doc.id);

    // Step 2: Create notification records for each follower
    const notificationPromises = followers.map(async (followerId) => {
       // Step 3: Create records in the user object for notifications
       await this.afs.doc(`users/${followerId}/user-notifications/${notId}`).set({
        read: false,
        timestamp: new Date()
      });
    });
  
    await Promise.all(notificationPromises);

    await this.afs.doc(`events/${id}`).set({
       id,
       eventId: id,
       partner: true,
       ...eventObject
    });

    try {
      if (sendNotification) {
        this.sendNotificationToUsers(followers, event.fullName, user.displayName, id);
      }
    } catch(e) {
      console.log(e);
    }
  }

  async getCoinsData(brandId: string): Promise<any> {
    const snapshot = await this.afs.collection('referred-coins', ref => ref.where('referred', '==', brandId)).get().toPromise();
    return snapshot.docs.map(doc => doc.data());
  }

  async getUserTransactions(brandId: string): Promise<any> {
    const snapshot = await this.afs.collection(`referrals/${brandId}/referrals-transactions`).get().toPromise();
    return snapshot.docs.map(doc => doc.data());
  }

  async getUserDetails(userId: string): Promise<any> {
    const doc = await this.afs.doc(`users/${userId}`).get().toPromise();
    return doc.data();
  }

  async getBrandIds(): Promise<any[]> {
    try {
      const snapshot = await this.afs.collection('referrals').get().toPromise();
      console.log(snapshot.size); // Log the size of the snapshot to check how many docs were fetched
      return snapshot.docs.map(doc => doc.id);
    } catch (error) {
      console.error("Failed to fetch brand IDs:", error);
      return []; // Return an empty array in case of error
    }
  }
  
  async getBrandNameById(brandId: string): Promise<string> {
    const doc: any = await this.afs.doc(`brands/${brandId}`).get().toPromise();
    return doc.exists ? doc.data().name : brandId; // Return the brand name or the ID if no name is available
  }

  public async xdeleteGift(code: string, userId: string): Promise<void> {
    // add here the decrease the amount property in the 
    // this.afs.collection('gifts').doc(code) by one 
    return this.afs.collection('user-gifts').doc(userId).collection('gifts').doc(code).set({
      used: true
   }, {merge: true});
  }

  public async deleteGift(code: string, userId: string): Promise<string> {
    const userGiftDocRef = this.afs.firestore.collection('user-gifts').doc(userId).collection('gifts').doc(code);
  
    const giftDoc = await userGiftDocRef.get();
  
    if (!giftDoc.exists) {
      return 'no-exists';
    }
  
    const giftData = giftDoc.data();
  
    if (giftData?.used) {
      return 'used';
    }
  
    await this.afs.firestore.runTransaction(async (transaction) => {
      // Mark the gift as used for the user
      transaction.set(userGiftDocRef, { used: true }, { merge: true });
    });
  
    return 'success';
  }

  public async createGift(gift: any, code: string): Promise<void> {
    code = code.toLowerCase();

    if (!gift.image.includes('http')) {
      const blobImage = this.dataURItoBlob(gift.image)
      gift.image = await this.downloadAndSaveEventImage(blobImage, code);
    }

    const giftObject = {
      ...gift,
    };

    delete giftObject.code;
    await this.afs.doc(`gift-events/${code}`).set({
       id: code,
       ...giftObject,
    });
  }

  public async sendNotificationOfCreatedEvent(obj: ISendNotificationOfCreatedEvent): Promise<void> { 
    const notId = this.afs.createId();

    const userInfo: any = await this.getUserInfo(obj.user.uid ? obj.user.uid: obj.user.userId);
    const brandId = userInfo.brandId;
    await this.afs.doc(`notifications/${notId}`).set({
      id: notId,
      brand: obj.user.brandId,
      brandImage: obj.user.image,
      title: obj.notificationTitle,
      description: obj.event.description,
      eventId: obj.event.eventId,
      timestamp: new Date()
    });

    // Step 1: Get the followers of the brand
    const followersSnapshot = await this.afs
    .collection(`followers/${brandId}/user-followers`)
    .get().toPromise();

    const followers = followersSnapshot.docs.map((doc) => doc.id);

    // Step 2: Create notification records for each follower
    const notificationPromises = followers.map(async (followerId) => {
       // Step 3: Create records in the user object for notifications
       await this.afs.doc(`users/${followerId}/user-notifications/${notId}`).set({
        read: false,
        timestamp: new Date()
      });
    });
  
    await Promise.all(notificationPromises);
    try {
        // Step 1: Get the followers of the brand
        const followersSnapshot = await this.afs
        .collection(`followers/${brandId}/user-followers`)
        .get().toPromise();

        const followers = followersSnapshot.docs.map((doc) => doc.id);

        this.sendNotificationToUsers(followers, obj.notificationTitle, obj.user.displayName, obj.event.id);
    } catch(e) {
      console.log(e);
    }
  }

  checkToSendNotification() {
    
  }


  public async editEvent(event: IEvent, user: any, sendNotification: boolean): Promise<void> {

    if (!event.image.includes('http')) {
      const blobImage = this.dataURItoBlob(event.image)
      event.image = await this.downloadAndSaveEventImage(blobImage, event.id);
    }

    const userInfo: any = await this.getUserInfo(user.uid ? user.uid: user.userId);
    const brandId = userInfo.brandId;

    const searchTags = this.getSearchTags(user.displayName, event.description);

    const now = new Date();

    const eventObject = {
      createdAt: now,
      ...event,
      searchTags
    };

    await this.afs.doc(`events/${event.id}`).set({
       ...eventObject
    }, {merge: true});

    try {
      if (sendNotification) {
        // Step 1: Get the followers of the brand
        const followersSnapshot = await this.afs
        .collection(`followers/${brandId}/user-followers`)
        .get().toPromise();

        const followers = followersSnapshot.docs.map((doc) => doc.id);

        this.sendNotificationToUsers(followers, event.fullName, user.displayName, event.id);
      }
    } catch(e) {
      console.log(e);
    }
  }


  public async getFollowersForBrand(brandId: string): Promise<string[]> {
    try {
      const querySnapshot = await this.afs.collection('followers')
        .doc(brandId)
        .collection('user-followers')
        .get()
        .toPromise();
  
        const followers: string[] = [];
      
        for (const doc of querySnapshot.docs) {
          const userId = Object.values(doc.data())[0];
          const userExists = await this.checkUserExists(userId);
    
          if (userExists) {
            followers.push(userId);
          }
        }
  
        console.log('');
        console.log('');
        console.log('followers ', followers);
        console.log('');
        console.log('');
  
      return followers;
    } catch (error) {
      console.error('Error retrieving followers:', error);
      return [];
    }
  }

      // Function to fetch push notification tokens of users
      private async getPushNotificationTokens(userIds: string[]): Promise<string[]> {
        const tokens: string[] = [];
      
        try {
          const getUserInfoPromises = userIds.map((userId) =>
            new Promise<string>(async (resolve, reject) => {
              try {
                const user = await this.getUserInfo(userId);
                if (user && user.pushNotificationToken) {
                  tokens.push(user.pushNotificationToken);
                }
                resolve(user.pushNotificationToken);
              } catch(e) {
                console.log(e);
              }
            })
          );
      
          await Promise.all(getUserInfoPromises);
          return tokens;
        } catch (error) {
          console.error('Error retrieving push notification tokens:', error);
          return [];
        }
      }
      
async getEventFromURL(url: string) {
  return new Promise(async (resolve, rejects)=>{
    try {

    const res: any = {};
    const options: any = {
      method: 'GET',
      url: 'https://instagram-scraper-api2.p.rapidapi.com/v1/post_info',
      params: {
        code_or_id_or_url: url
      },
      headers: {
        'X-RapidAPI-Key': this.rapidKey,
        'X-RapidAPI-Host': 'instagram-scraper-api2.p.rapidapi.com'
      }
    };
    const response = await axios.request(options);
      if (response.data.data) {
        const newId = this.afs.createId();
        res['image'] = await this.downloadAndSaveImage(response.data.data.thumbnail_url, newId);
        res['description'] = response.data.data.caption.text;
        res['title'] = response.data.data.user.full_name;
        resolve(res);
      }      
    } catch(e) {
      resolve(null);
    }
  });
}

// Function to send a notification to users
async sendNotificationToUsers(userIds: string[], notification: any, brand: string, eventId: string) {
  const tokens = await this.getPushNotificationTokens(userIds);

  console.log('');
  console.log('');
  console.log('tokens ', tokens);
  console.log('');
  console.log('');
  try {

    for (const token of tokens) {
      console.log('');
      console.log('');
      console.log('');
      console.log('');
      console.log('notification ', notification);
      console.log('token ', token);
      console.log('eventId ', eventId);
      console.log('brand ', brand);
      console.log('');
      console.log('');
      console.log('');
      console.log('');
      const message = {
        "to": token,
        "notification": {
          "body":  notification,
          "content_available": true,
          "priority": "high",
          "title": brand,
          "sound" : "default"
        },
        "data": {
          "eventId": eventId
        }
      };

      fetch('https://fcm.googleapis.com/fcm/send', {
        method: 'POST',
        headers: {
          'Authorization': `key=AAAA1H8peQA:APA91bFFXYBb_y7oUhr1e8yj4vfIPWF_r_a2SqpE8CAyXlJU4onMQbF7NX37_0hitjO3UIrn2HhJmlyUQ8u83w70cuMH99askiqNASPF_m5kgQsLINOI00PZF31_i8gBHiZBcntn3cxq`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(message)
      })
        .then(response => response.json())
        .then(data => {
          console.log('Notification sent:', data);
        })
        .catch(error => {
          console.error('Error sending notification:', error);
        });
    }
  } catch (error) {
    console.error('Error sending notification:', error);
  }
}


  private async checkUserExists(userId: string): Promise<boolean> {
    try {
      const userDoc = await this.afs.collection('users').doc(userId).get().toPromise();
      if (userDoc.exists) {
        const userData: any = userDoc.data();
        if (userData && userData.userId) {
          return true; // User document exists and has a userId field
        }
      }
      return false; // User document doesn't exist or doesn't have a userId field
    } catch (error) {
      console.error('Error checking user existence:', error);
      return false;
    }
  }
  

  public async getEventsFromUser(username: string): Promise<IEvent[] | null> {
    try {
      // Fetch events from the Firestore collection where the brand is equal to the username
      const querySnapshot = await this.afs
        .collection('events', (ref) => ref.where('brand', '==', username))
        .get()
        .toPromise();
  
      if (!querySnapshot.empty) {
        // Map each document to the event and initiate count promises
        const eventsPromises = querySnapshot.docs.map(async (doc) => {
          const event = doc.data() as IEvent;
          const eventId = event.eventId;
  
          // Create an array to store promises for getting counts
          const countPromises: Promise<number>[] = [];
  
          // Get count of records in events-clicked where eventId === event.eventId
          countPromises.push(this.getCount('events-clicked', eventId));
  
          // Get count of records in events-feedback where eventId === event.eventId
          countPromises.push(this.getCount('events-feedback', eventId));
  
          // Get count of records in events-saved where eventId === event.eventId
          countPromises.push(this.getCount('events-saved', eventId));
  
          // Get count of records in events-shared where eventId === event.eventId
          countPromises.push(this.getCount('events-shared', eventId));
  
          // Get count of records in events-wanted-to-reserve where eventId === event.eventId
          countPromises.push(this.getCount('events-wanted-to-reserve', eventId));
  
          // Get count of records in events-liked where eventId === event.eventId
          countPromises.push(this.getCount('events-liked', eventId));
  
          // Wait for all count promises to resolve
          const counts = await Promise.all(countPromises);
  
          // Assign counts to the corresponding event
          event['clicks'] = counts[0];
          event['feedback'] = counts[1];
          event['saved'] = counts[2];
          event['shared'] = counts[3];
          event['wantToReserve'] = counts[4];
          event['likes'] = counts[5];
  
          return event;
        });
  
        // Wait for all events promises to resolve
        const events = await Promise.all(eventsPromises);
  
        return events;
      } else {
        return [];
      }
    } catch (error) {
      this.somethingWentWrong(error, 'Error fetching events.');
      throw error;
    }
  }
  
  private async getCount(collectionName: string, eventId: string): Promise<number> {
    const snapshot = await this.afs
      .collection(collectionName, (ref) => ref.where('eventId', '==', eventId))
      .get()
      .toPromise();
  
    return snapshot.size;
  }
  

  public async getFollowersFromUser(userId: string): Promise<User[]> {
    try {
      // Fetch followers from the Firestore collection where userId matches the follower's ID
      const userFollowersSnapshot = await this.afs
        .collection(`followers/${userId}/user-followers`)
        .get()
        .toPromise();

      const followerIds = userFollowersSnapshot.docs.map((doc) => doc.id);

      const followerPromises = followerIds.map(async (followerId) => {
        const userDoc = await this.afs.collection('users').doc(followerId).get().toPromise();
        return userDoc.data() as User;
      });

      return Promise.all(followerPromises);
    } catch (error) {
      this.somethingWentWrong(error, 'Error fetching followers.');
      throw error;
    }
  }

  public async getNotificationsCountForCurrentMonth(brandId: string): Promise<number> {
    try {
      // Get the current date to filter notifications for the current month
      const currentDate = new Date();
      const currentMonthStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      const currentMonthEnd = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
  
      // Fetch notifications from the Firestore collection where brand is equal to user's brandId
      const userNotificationsSnapshot = await this.afs
        .collection('notifications', (ref) => ref.where('brand', '==', brandId))
        .get()
        .toPromise();
  
      // Filter notifications for the current month
      const notificationsForCurrentMonth = userNotificationsSnapshot.docs
        .filter((doc) => {
          const timestamp = doc.get('timestamp') as firebase.firestore.Timestamp;

          return (
            timestamp.toDate() >= currentMonthStart &&
            timestamp.toDate() <= currentMonthEnd
          );
        });

  
      // Return the count of notifications for the current month
      return notificationsForCurrentMonth.length;
    } catch (error) {
      this.somethingWentWrong(error, 'Error fetching notifications count.');
      throw error;
    }
  }

  async eventHasNotificationSent(event: IEvent) {
    const userNotificationsSnapshot = await this.afs
    .collection('notifications', (ref) => ref.where('eventId', '==', event.eventId))
    .get()
    .toPromise();
    return !userNotificationsSnapshot.empty;
  }
  
}
